import { Campaign, CampaignChartFilters, MediaFormat } from 'types/campaign'
import api from 'api'
import {
  AudienceFilters,
  CampaignEmission,
  CampaignImpressionResponse,
  CampaignLocalFilters,
} from './types'
import { PublicViewProps } from '../types'
import { store } from '../../../../store'
import { campaignDetailsActions } from '../store/campaign-details-slice'

export default class CampaignDetailsChartService {
  static fetchImpressions = (
    campaignId: Campaign['id'],
    publicViewProps: PublicViewProps | undefined,
    selectedFilters: CampaignLocalFilters,
    selectedAudienceFilters: AudienceFilters,
    areFiltersTheSame: boolean
  ): Promise<unknown> => {
    const broadsignCreationIds: number[] = selectedFilters.broadsignCreationIds
      ? selectedFilters.broadsignCreationIds.map(id => parseInt(id))
      : []
    const { pois } = selectedFilters
    const areAllPoisSelected = selectedFilters.pois.length === selectedFilters.pois.length
    const isDgClFormat =
      store.getState().campaignDetails.campaignData?.mediaCriteriaSearch.mediumFormat ===
      MediaFormat.DG_CL
    const variables = {
      ...selectedFilters,
      broadsignCreationIds: broadsignCreationIds,
      ...(isDgClFormat ? { buildings: [] } : {}),
      pois: areAllPoisSelected ? [] : pois,
      sex: selectedAudienceFilters.sex,
      ageGroups: selectedAudienceFilters.ageGroups,
    }

    return Promise.resolve(store.dispatch(campaignDetailsActions.setChartLoading(true)))
      .then(() => {
        return CampaignDetailsChartService.fetchPureCampaignImpressions(
          campaignId,
          publicViewProps,
          variables,
          areFiltersTheSame
        )
      })
      .then(campaignResponseImpressions => {
        const emissions = campaignResponseImpressions.map(
          (impression: CampaignImpressionResponse): CampaignEmission => {
            return {
              audience: impression.audience,
              date: impression.date,
              totalAudience: impression.totalAudience,
              emissions: impression.impressions,
              totalEmissions: impression.totalImpressions,
              estimated: impression.estimated,
              broadsignImpressions: impression.broadsignImpressions,
              requestsCount: impression.requestsCount,
              adCount: impression.adCount,
              noAdCount: impression.noAdCount,
              theoreticalEmissions: impression.theoreticalEmissions,
            }
          }
        )

        void store.dispatch(campaignDetailsActions.setChartEmissions(emissions))
        void store.dispatch(campaignDetailsActions.setChartLoading(false))
      })
  }

  static fetchPureCampaignImpressions = (
    campaignId: Campaign['id'],
    publicViewProps: PublicViewProps | undefined,
    variables: CampaignChartFilters,
    areFiltersTheSame: boolean
  ): Promise<CampaignImpressionResponse[]> => {
    const { publicView, campaignUuid } = publicViewProps || {}

    const useFilters = !areFiltersTheSame

    if (publicView && campaignUuid) {
      const query = api.campaign.getCampaignImpressionsPublic({
        campaignUuid,
        useFilters,
        ...variables,
      })

      return query.then(res => {
        if (!res.data) {
          return []
        }

        return res.data.campaignReportPublic.campaignImpressions.nodes
      })
    }

    const query = api.campaign.getCampaignImpressions({
      campaignId,
      useFilters,
      ...variables,
    })

    return query.then(res => {
      if (!res.data) {
        return []
      }

      return res.data.campaignImpressions.nodes
    })
  }
}
